import MapTraveler from "../../../assets/svgs/travel_tracker_white.svg";

export default {
  Id: 1,
  Name: "Traveler",
  Discriminator: "ISOS",
  Icons: {
    Map: MapTraveler,
  },
};
